export const API_URL = {
	// Mints a Firebase custom token so the panel can sign in to the Realtime DB.
	FIREBASE_TOKEN: '/firebase-token',
	KYC_SETTINGS: '/kyc-settings',
	ONBOARDED_SUMMARY: '/onboarding-summary',
	CLIENT_DETAILS: '/details',
	INVITES: '/invites',
	CREDENTIAL: '/credentials',
	PIPELINE_INIT: '/pipeline-init',
	/* The vendor rate card behind Global Data Validation: one row per country at
	   cost + margin. `/pipeline-init` quotes the reference country on the tile;
	   this is the full sheet the tile's chip opens. */
	DATA_VALIDATION_RATES: '/data-validation-rates',

	/* Transaction monitoring (KYT), served by `transaction.monitoring.api`.
	   The gateway routes /v1/transaction-monitoring/* straight to that service
	   (see _infra/gateway.nginx.conf and the dev2 api-gateway configmap); it is
	   NOT proxied through simplici.api, so these paths carry the service prefix
	   and everything after it is the service's own route. */
	TM_ALERTS: '/transaction-monitoring/alerts',
	TM_TRANSACTIONS: '/transaction-monitoring/transactions',
	TM_COUNTRY_COVERAGE: '/transaction-monitoring/country-coverage',
	TM_DATA_FEEDS: '/transaction-monitoring/data-feeds',
	TM_STATS: '/transaction-monitoring/transaction-stats',
	TM_RULES: '/transaction-monitoring/monitoring-rules',
	TM_SUBJECTS: '/transaction-monitoring/subjects',
	TM_CASES: '/transaction-monitoring/cases',
	/* The pre-filled SAR for a flagged transaction / alert / case. GET by
	   transaction id; POST {caseId, subject?, persist} to save officer input. */
	TM_SAR_DRAFTS: '/transaction-monitoring/sar-drafts',
	/* SAR batches sent to FinCEN over SDTM, plus the connection state:
	   GET ?caseId= answers {connection, submissions[]}. */
	TM_FINCEN_SUBMISSIONS: '/transaction-monitoring/fincen-submissions',
	/* The business's SAR filer identity (transmitter, filing institution,
	   contact office). GET answers {businessId, profile, updatedAt}. */
	TM_SAR_FILER_PROFILES: '/transaction-monitoring/sar-filer-profiles',
	TM_IMPORTS: '/transaction-monitoring/import-batches',
	TM_FX_RATES: '/transaction-monitoring/fx-rates',
	/* The blank CSV template. Served as a FILE (text/csv + Content-Disposition)
	   by a plain express route mounted before xitkov, so unlike everything above
	   it does not answer with the `{message, data}` envelope and is fetched
	   directly rather than through `useNetwork`. */
	TM_IMPORT_TEMPLATE: '/transaction-monitoring/import-template.csv',
	PIPELINE_TEMPLATE: '/pipeline-templates',
	PIPELINE_USERS: '/pipeline-users',
	CHECKOUT: '/checkout',
	BUSINESSES: '/businesses',
	EMAIL_CLIENTS: '/email-clients',
	CLIENT_LOGIN: '/login',
	CLIENT_SIGNUP: '/users',
	ADD_SIGN_DOC: '/signing/file/upload',
	SIGN_DOC: '/signing/documents',
	USER_ROLES: '/invite-users',
	ROLES: '/business-roles',
	SESSIONS: '/session-lists',
	SESSION_DETAIL: '/session-details',
	LINK_ENVELOPES: '/link-envelopes',
	ACTIVITIES: '/session-activities',
	INVITE_INVESTOR: '/invite-user',
	INVESTOR: '/investors',
	RESEND_INVITE: '/resend-invite',
	FUNDS: '/funds',
	BILLING: '/onboarding-billings',
	LOGOUT: '/logout',
	INVOICE: '/onboarding-invoices',
	FUND_DETAIL: '/fund-details',
	SAVE_TEMPLATE: '/save-template',
	SIGN_AGREEMENT: '/templates',
	SIGN_AGREEMENT_TEMPLATE_LIST: '/template-list',
	UPLOAD_AGREEMENT_TEMPLATE: '/url/upload',
	SIGN_CONFIG_STATUS: '/sign-configure-status',
	SIGN_AGREEMENT_DOC: '/signing',
	BUSINESS_CARD: '/business-cards',
	BUSINESS_PAYMENT_DETAILS: '/business-payment-details',
	CLIENT_TOKENS: '/tokens',
	BUSINESS_KYB: '/business-kyb',
	FORGOT_PW_MAIL: '/member-email-codes',
	FORGOT_PW_CODE: '/verify-emails',
	FORGOT_PW_RESET: '/reset-password',
	CUSTOM_PRICE: '/custom-pricing',
	GOOGLE_FONDS: '/google-fonts',
	WebAuthLogin: '/web-auth-login',
	PhoneCodes: '/phone-codes',
	WaitingLogin: '/events',
	LoginStatus: '/status',
	VerifyPhones: '/verify-phones',
	Transactions: '/pipeline-transactions',
	GenerateLinkToken: '/link-tokens',
	TokenExchange: '/token-exchange',
	BusinessBankAccounts: '/business-bank-accounts',
	SESSION_REPORTS: '/session-reports',
	GET_UPLOADED_DOCUMENTS: '/session-file-upload/',
	UPLOAD_DOCUMENTS: '/session-file-upload',
	ARCHIVE_SESSION: '/sessions',
	/* The transaction record — one monitored transaction as a compliance
	   document, in pdf/csv/xlsx. Served by transaction.monitoring.api, which is
	   why it carries the `/transaction-monitoring` prefix the gateway routes on;
	   without it the request falls through to `location /v1/`, reaches
	   simplici.api, and 404s from a service that has no such path. */
	TRANSACTION_REPORTS: '/transaction-monitoring/transaction-reports',
	SESSION_FUND_ASSIGN: '/session-fund-assign',
	SESSION_CONFIGURE: '/session-configurations',
	CLIENT_SOCIAL_LOGIN: '/social-login',
	GA_FUNNEL: '/pipeline-ga-Funnel?from=',
	CHART_AVERAGE_TIME: '/session-average-time?isDeleted=false&from=',
	CLIENT_IDENTITY: '/identities',
	STATE_CITY: '/country-state-city',
	SUPPORT_AGENT: '/agent-analytics',
	TEMPLATE_STATUS: '/template-status',
	MONTHLY_SUBSCRIPTION: '/monthly-subscription',
	USER_LOGIN: '/user-login',
	PHONE_CODES: '/phone-codes',
	VERIFY_CODES: '/verify-codes',
	// approve-by-email for phone/email changes (spec 17)
	PROFILE_CHANGE_REQUESTS: '/profile-change-requests',
	PROFILE_CHANGE_APPROVALS: '/profile-change-approvals',
	ENVELOPE: '/envelopes',
	/** Mints the short-lived, evault-scoped token the web component authenticates with. */
	VAULT_TOKENS: '/vault-tokens',
	/** eVault add-on purchase/status (billing page "Add on Service" card). */
	EVAULT_ADDONS: '/evault-addons',
	/** One row per committed eVault ownership transfer (billing page "eVault transfers" tab). */
	EVAULT_TRANSFER_CHARGES: '/evault-transfer-charges',
	/** Enrols a face for one pending vault transfer; answers the token `commit` needs. */
	FACE_VERIFICATIONS: '/face-verifications',
	LINKED_ENVELOPES: '/link-envelopes',
	ESIGN_CERTIFICATE: '/esign-certificate',
	ENVELOPE_SIGN: '/envelope-url',
	ENVELOPE_STATUS: '/envelope-status',
	SIGN_INVITE: '/sign-invite',
	MONTHY_SUBSCRIPTION: '/monthly-subscription',
	ATTACHMENT: '/url/attachment',
	SIGN_USER_DASHBOARD: '/sign-dashboard',
	USER_SIGNATURE: '/signatures',
	COMPLEX_INIT: '/complex-init',
	COMPLEX_FLOW: '/complex-flow',
	COMPLEX_NODE_REFERENCES: '/complex-node-references',
	COMPLEX_INVITE: '/complex-invite',
	COMPLEX_SESSION_INFO: '/session-info',
	COMPLEX_SESSION: '/complex-sessions',
	COMPLEX_SESSION_DETAILS: '/complex-session-details',
	ONBOARDING_CIP: '/onboarding-cip',
	ONBOARDING_TIER1: '/onboarding-tier-1',
	BILLING_TRANSACTION: '/revenue',
	PIPELINE_QR: '/pipeline-qr',
	COMPLEX_QR: '/complex-qrs',
	SUBSCRIPTIONS: '/subscriptions',
	USER_VERIFICATION: '/user-verifications',
	Business_Registration: '/business-registration',
	SandBox_Signup: '/sandbox-user-registration?email=',
	Payment_Methods: '/payment-methods',
	Session_Nodes: '/session-nodes',
	COMPLEX_SESSION_NODES: '/complex-session-nodes',
	/* The Multi Session Bundle drawer: every session that looks like the
	   same person as this one, with the evidence for saying so. */
	SESSION_BUNDLE: '/session-bundle',
	STEP_TEMPLATES: '/step-templates',
	SUBSCRIPTION_PRICE: '/pricing',
	PACKET_EDIT: '/packet-edit',
	SUB_ACCOUNT: '/sub-account',
	DEALS: '/deals',
	EDIT_RECIPIENTS: '/edit-recipients',
	BUSINESS_COMPLIANCE: '/business-compliance',
	BUSINESS_COMPLIANCE_ID: '/business-compliance?businessId=',
	ASSIGNEE_USERS : '/assignee-users',
	SESSION_ASSIGNEE: '/session-assignee',
	
	// MFA
	MFA_VERIFY: '/mfa-verify',
	MFA_SETUP: '/mfa-setup',
	BACK_UP_CODES: '/mfa-backup-codes',

	// Encrption Key
	EncryptKey: '/encryption-key',

	// Verify Refresh Token
	VERIFY_REFRESH_TOKEN :'/access-tokens',

	//dummy apis
	ESCROW_TRANSACTION: '/escrow-transaction',
	ESCROW_ACCOUNT: '/escrow-accounts',
	PIPELINE_PRICING: '/pipeline-pricing?pipelineId',
	ENVELOPE_HISTORY: '/envelope-logs',
	SIGNATURE_FONT: '/signatures',
	PACKET_DETAILS: '/packet-details',
	RECIPIENT_KYC: '/recipient-kyc',
	DOCUMENTS: '/documents',
	CHEQUE_DEFENCE_TRANSACTION: '/check-defense-transaction',
	CHEQUE_DEFENCE_SESSION: '/check-defense-session',
	CHEQUE_DEFENCE_BANK: '/check-defense-bank',
	USER_ACCESS_TOKEN: '/user-access-tokens',
	MEDIA: '/media',
	RESEND_DOC_INVITES: '/resend-docs-invites',
	UPLOAD_PROOF: '/upload-proof',
	PING: '/ping',
	INVOICES: '/invoices',
	RESEND_DOCUMENT: '/resend-document',
	QR_FLOWS: '/qr-invite',
	PROVIDERS: '/providers',
	NODE_STEPS: '/node-steps',
    PRE_SIGN_UPLOAD: '/pre-signed-upload', // Endpoint to retrieve a pre-signed upload URL

	DRAFT_ENVELOPE: '/draft-envelope',
	BIOMETRICS: '/biometrics',
	KYB_COUNTRIES:"/kyb-countries",
	ACCESS_CODE: "/access-code",
	CRD_CHECK: "/crd-check",
	USER_LOCATIONS_COUNTRIES: '/user-locations?action=countries',
	USER_LOCATIONS: '/user-locations',
};

export const GOOGLE_API = {
	MAP: 'https://www.google.com/maps/search/?api=1&query=',
	IP: 'https://us-central1-glossy-fastness-305315.cloudfunctions.net/locate',
};

//captable apis
export const GET_CAPTABLE = {
	BASIC_INFORMATION_URL:
		'https://api.stage.satschel.com/v2/captable/basic-information',
	BASIC_INFORMATION: '/basic-information',
	SETUP: '/setup',
	STAKEHOLDER: '/simplici-stakeholder',
};
